import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MbscModule } from '@mobiscroll/angular';

import { IconService } from '../../../../services/shared/icons/icon.service';
import { ColorService } from '../../../../services/shared/color/color.service';
import {
  categoryData,
  platformIcons,
  statusData
} from '../../../../interfaces/selectData';

@Component({
  selector: 'app-event-view',
  imports: [CommonModule, MbscModule, FormsModule],
  templateUrl: './event-view.component.html',
  styleUrl: './event-view.component.scss'
})
export class EventViewComponent implements OnChanges {
  @Input() filteredTasks: any[] = [];
  @Input() tasks: any[] = [];
  @Input() event: any;
  @Input() myEvents: any;
  @Input() inst: any;
  @Input() interpreter: any;
  @Input() dragging: any;
  @Input() filteredCustomers: any;

  statusData = statusData;
  categoryData = categoryData;
  platformIcons = platformIcons;
  missing: boolean = false;
  coIds: number[] = [];
  coData: any;
  fremdData: any;

  constructor(
    public iconService: IconService,
    public colorService: ColorService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['event'] || changes['myEvents'] || changes['interpreter']) {

      const currEvent = this.event;
      if (!currEvent) return;

      if (typeof currEvent.onlineLink === 'string') {
      try {
        const parsed = JSON.parse(currEvent.onlineLink);
        currEvent.onlineLink = Array.isArray(parsed) ? parsed : [];
      } catch {
        currEvent.onlineLink = [];
      }
    } else if (!Array.isArray(currEvent.onlineLink)) {
      currEvent.onlineLink = [];
    }

      if (currEvent.isTemplate === 1 || currEvent.type === 'TEMPLATE') {
        this.coData = [];
        this.fremdData = [];
        return;
      }

      const allEvents = this.myEvents || [];
      const allResources = this.interpreter || [];

      if (!allEvents.length || !allResources.length) {
        this.coData = [];
        this.fremdData = [];
        return;
      }

      this.loadCoInterpreters(currEvent, allEvents, allResources);

      this.loadFremdInterpreterInfo(currEvent);
    }
  }

  private loadCoInterpreters(currEvent: any, allEvents: any[], allResources: any[]): void {
    const currId = String(currEvent.id ?? '').trim();
    const baseId = currId.split('-')[0];
    
    if (!baseId) {
      this.coData = [];
      return;
    }

    const relatedEvents = allEvents.filter((ev: any) => {
      if (!ev?.id) return false;
      const evBase = String(ev.id).split('-')[0];
      return evBase === baseId;
    });

    const resourceIds = relatedEvents.flatMap((ev: any) => ev.resource || []);
    const uniqueResourceIds = [...new Set(resourceIds)];

    const matchedResources = uniqueResourceIds
      .map((id) => allResources.find((res: any) => String(res.id) === String(id)))
      .filter(Boolean);

   this.coData = matchedResources;
    //console.log('coData : ', this.coData)
  }

private loadFremdInterpreterInfo(currEvent: any): void {
  if (typeof currEvent.informations === 'string') {
    try {
      const parsed = JSON.parse(currEvent.informations);
      currEvent.informations = Array.isArray(parsed) ? parsed : [];
    } catch {
      currEvent.informations = [];
    }
  } else if (!Array.isArray(currEvent.informations)) {
    currEvent.informations = [];
  }
  this.fremdData = currEvent.informations.find(
    (info: any) => info?.checked === true
  );

  //console.log('fremdData',this.fremdData)
}

 getCustomerNames(event: any): string {  
    let customers = event?.original?.customer ?? event?.customer;
 
    if (!Array.isArray(customers) || customers.length === 0) {
      return '- ?'; // kein Customer vorhanden
    }
  
    const names = customers.map(customer =>(
      customer.firstname + ' ' + customer.lastname
    )).join(' ,')

    if(names.includes('null')){
      return '- ?'
    }else{
      return names ? `- ${names}` : '- ?';
    }
  }
}